// src/data/pravachanUtil.js

// Group pravachan records by MM-DD
export function getPravachanByMonthDay(pravachanList) {
  const grouped = {};
  pravachanList.forEach((item) => {
    if (!item.PrvDate) return;
    // PrvDate format: yyyy-mm-dd
    const [, mm, dd] = item.PrvDate.split("-");
    const key = `${mm}-${dd}`;
    if (!grouped[key]) grouped[key] = [];
    grouped[key].push(item);
  });
  return grouped;
}
